import { topscroll } from "./topscroll";
import { midscroll } from "./midscroll";
import { welcomePage } from "./welcomepage";
import { doubleMidscroll } from "./double-midscroll";
import { tripleMidscroll } from "./triple-midscroll";
import { doubleMidscrollSingle } from "./double-midscroll-single";

export const defaultFormats = [
    topscroll,
    midscroll,
    welcomePage,
    doubleMidscroll,
    tripleMidscroll,
    doubleMidscrollSingle
];
